module.exports = __webpack_public_path__ + "img/jin.fdbf0d89.png";